module.exports = __webpack_public_path__ + "assets/fonts/wallet.a4e14f8b.svg";